import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../Translations';

interface Props {
  href: string;
}

function PrivacyPolicyLink({ href }: Props) {
  return (
    <T
      kind="<link1>Privacy ..."
      link1={(content) => (
        <a
          data-testid="footer_privacy-policy-link"
          data-test-privacy-policy-link={true}
          data-intercom-target="footer-privacy-policy-link"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Typography
            className="text-foreground underline hover:text-primary"
            variant="bodyMedium"
            fontWeight="semibold"
            as="span"
          >
            {content}
          </Typography>
        </a>
      )}
    />
  );
}

export default observer(PrivacyPolicyLink);
